<template lang="pug">
  div(class="content")
    .md-layout.md-alignment-center-center
      div(class="md-layout-item md-size-45 md-medium-size-60 md-small-size-80")
        <md-card>
          <md-card-header data-background-color="green">
            <md-card-header-text>
              <div class="md-title">Box Access Preview</div>
              <div class="md-subhead">Get a preview of the Box resources USIT has to offer.</div>
            </md-card-header-text>

            <md-card-media md-big>
              <md-icon class="md-size-5x">cloud</md-icon>
            </md-card-media>
          </md-card-header>

          <md-card-actions>
            <a :href='source' target="_blank"><md-button>Go</md-button></a>
          </md-card-actions>
        </md-card>

    //- div(class="md-layout" style="height: 70vh;")
    //-   div(class="md-layout-item md-size-10 md-xsmall-size-100 centered")
    //-     md-button.md-raised(v-if="!notLoaded" :href="source" target="_blank") Open in New Window
    //-   div(v-if="notLoaded" class="md-layout-item md-size-100 centered")
    //-     loading
    //-   iframe(id="frame" :class="[{loading: notLoaded}, 'md-image']" @load="notLoaded = false" :src="source" width="97%" height="100%" frameborder="0")
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return{
      source: 'https://usit.box.com/s/fuf63w7c7e1do06dsvlpswnih28l6kkl',
      notLoaded: true,
    };
  }
}
</script>

<style scoped>
  .content {
    padding-top: 0px;
  }

  .centered {
    text-align: center;
  }

  .loading {
    display: none;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Resources/BoxPreview.vue